import { VARIANT_A } from '../../experiments/experimentDefaults';
import { ExperimentKeys } from '../../experiments/ExperimentKeys';
import { getFlowSteps } from '../../flow-initial/getFlowConfig';
import { isPostVerification } from '../../flow-settings/settingsSelectors';
import { getIsActiveAndAssignedToVariant } from '../../store/experiments/selectors';
import { setFlow } from '../../store/flow/action-creators';
import { Step } from '../../views/Step';
export const BranchOnePageSignupACQ126 = {
  name: 'BranchMoveVerificationStepsACQ126',
  stateCheck: state => getIsActiveAndAssignedToVariant(state, ExperimentKeys.ACQ126, [VARIANT_A]),
  rebuildFlow: (flow, _state, dispatch) => {
    const postVerification = [Step.Password];
    const {
      postAccountCreation,
      postExistingAccountSelection
    } = getFlowSteps();
    const preVerificationSteps = !isPostVerification() ? [Step.OnePageSignup, Step.CodeVerification] : [];
    const nextSteps = [...preVerificationSteps, ...postVerification, ...postAccountCreation, ...postExistingAccountSelection];
    dispatch(setFlow(nextSteps, preVerificationSteps, postVerification, postAccountCreation, postExistingAccountSelection));
    return nextSteps;
  },
  processed: false,
  processedOnStep: null,
  afterData: null,
  afterStep: null
};